module.exports = __webpack_public_path__ + "static/media/WhyWillIReceiveTwoBills.5cee5bcc.png";